import DownloadModal from './DownloadModal.component';

export default DownloadModal;